import { Injectable, signal, computed, Signal } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

/** Shell chrome state shared between layout, chat view, and auth flows. */
@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  /** Toggles welcome background on the main content pane (`ai-right-bg`). */
  private static readonly DEFAULT_TABLE_OFFSET = 250;

   
  private readonly viewportHeight = signal<number>(
    typeof window !== 'undefined' ? window.innerHeight : 0,
  );

  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () =>
      {
         
         this.viewportHeight.set(window.innerHeight);
          
      }
    
    );
    }
  }

  /**
   * @description Reactive scroll height for list-page tables. The returned signal
   * recomputes automatically on window resize, so pages no longer need their own
   * `heightChange`/resize handler — just bind `[style.height]="tableHeight()"`.
   * @param offset - px of chrome above the table (default 250).
   * @returns Signal<string> emitting a CSS height string, e.g. "620px".
   */
  getTableHeight(offset: number = HeaderService.DEFAULT_TABLE_OFFSET): Signal<string> {
    return computed(() => Math.max(0, Math.round(this.viewportHeight() - offset)) + 'px');
  }
  private readonly headerSubject = new BehaviorSubject<boolean>(true);
  private readonly loaderVisibleSubject = new BehaviorSubject<boolean>(false);
  private readonly aiSidebarVisibleSubject = new BehaviorSubject<boolean>(false);

  getHeader(): Observable<boolean> {
    return this.headerSubject.asObservable();
  }

  getLoaderVisibility(): Observable<boolean> {
    return this.loaderVisibleSubject.asObservable();
  }

  getAiSidebarVisibility(): Observable<boolean> {
    return this.aiSidebarVisibleSubject.asObservable();
  }

  setHeaderVisibility(visible: boolean): void {
    this.headerSubject.next(visible);
  }

  setLoaderVisibility(visible: boolean): void {
    this.loaderVisibleSubject.next(visible);
  }

  setAiSidebarVisibility(visible: boolean): void {
    this.aiSidebarVisibleSubject.next(visible);
  }
}
